export function isEmail (str: string = ''): boolean {
  return str.toLowerCase().match(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i) !== null
}

export function isRegCode (str: string = ''): boolean {
  return String(parseInt(str)).length === 8
}
